module.exports = __webpack_public_path__ + "static/media/p2008tech.16afefcb.jpg";